import MaterialSwitch from '@mui/material/Switch'; // Note that this implicitly renames the import from Switch to MaterialSwitch to avoid naming conflicts below. The MUI component is NOT named MaterialSwitch.
import type { JSX } from 'react';

interface SwitchProps {
    checked?: boolean;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    name?: string;
}

const switchStyle = {
    '& :hover': {
        backgroundColor: '#053c5910',
    },
    '& .Mui-checked': {
        '& .MuiSwitch-thumb': {
            color: '#053c59',
        },
        '& + .MuiSwitch-track': {
            backgroundColor: '#053c59',
        },
        '& :hover': {
            backgroundColor: '#053c59',
        },
    },
    '& .Mui-checked:hover': {
        backgroundColor: '#053c5910',
    },
} as const;

export function Switch(props: SwitchProps): JSX.Element {
    return <MaterialSwitch checked={props.checked} disabled={props.disabled} onChange={props.onChange} name={props.name} sx={switchStyle} disableRipple />;
}
